import { selectContentType } from '#src/lib/contentful/selectors.mjs';

import { mediaComponentsMap } from './helpers/media-components-map';

export function MediaComponent({ mediaRow, ...props }) {
  const Cmp = mediaComponentsMap[selectContentType(mediaRow)];
  return Cmp ? <Cmp mediaRow={mediaRow} {...props} /> : null;
}
